import { safeExecute, } from "@opendaw/lib-std";
import { Box, NoPointers, PointerField, Int32Field, StringField, BooleanField, Float32Field, } from "@opendaw/lib-box";
import { Pointers } from "@opendaw/studio-enums";
export class VocoderDeviceBox extends Box {
    static create(graph, uuid, constructor) {
        return graph.stageBox(new VocoderDeviceBox({
            uuid,
            graph,
            name: "VocoderDeviceBox",
            pointerRules: {
                accepts: [
                    Pointers.Device,
                    Pointers.Selection,
                    Pointers.MetaData,
                    Pointers.SideChain,
                ],
                mandatory: false,
                exclusive: false,
            },
            resource: undefined,
            ephemeral: false,
        }), constructor);
    }
    static ClassName = "VocoderDeviceBox";
    static Resource = undefined;
    static Ephemeral = false;
    static Tags = Object.freeze({ type: "device", deviceType: "audio-effect" });
    constructor(construct) {
        super(construct);
    }
    accept(visitor) {
        return safeExecute(visitor.visitVocoderDeviceBox, this);
    }
    get tags() {
        return VocoderDeviceBox.Tags;
    }
    get host() {
        return this.getField(1);
    }
    get index() {
        return this.getField(2);
    }
    get label() {
        return this.getField(3);
    }
    get enabled() {
        return this.getField(4);
    }
    get minimized() {
        return this.getField(5);
    }
    get carrierMinFreq() {
        return this.getField(10);
    }
    get carrierMaxFreq() {
        return this.getField(11);
    }
    get modulatorMinFreq() {
        return this.getField(12);
    }
    get modulatorMaxFreq() {
        return this.getField(13);
    }
    get qMin() {
        return this.getField(14);
    }
    get qMax() {
        return this.getField(15);
    }
    get envRelease() {
        return this.getField(16);
    }
    get mix() {
        return this.getField(17);
    }
    get bandCount() {
        return this.getField(18);
    }
    get modulatorSource() {
        return this.getField(19);
    }
    get envAttack() {
        return this.getField(20);
    }
    get gain() {
        return this.getField(21);
    }
    get sideChain() {
        return this.getField(30);
    }
    initializeFields() {
        return {
            1: PointerField.create({
                parent: this,
                fieldKey: 1,
                fieldName: "host",
                deprecated: false,
                pointerRules: NoPointers,
            }, Pointers.AudioEffectHost, true),
            2: Int32Field.create({
                parent: this,
                fieldKey: 2,
                fieldName: "index",
                deprecated: false,
                pointerRules: NoPointers,
            }, "index", ""),
            3: StringField.create({
                parent: this,
                fieldKey: 3,
                fieldName: "label",
                deprecated: false,
                pointerRules: NoPointers,
            }),
            4: BooleanField.create({
                parent: this,
                fieldKey: 4,
                fieldName: "enabled",
                deprecated: false,
                pointerRules: NoPointers,
            }, true),
            5: BooleanField.create({
                parent: this,
                fieldKey: 5,
                fieldName: "minimized",
                deprecated: false,
                pointerRules: NoPointers,
            }, false),
            10: Float32Field.create({
                parent: this,
                fieldKey: 10,
                fieldName: "carrierMinFreq",
                deprecated: false,
                pointerRules: {
                    accepts: [
                        Pointers.Modulation,
                        Pointers.Automation,
                        Pointers.MIDIControl,
                    ],
                    mandatory: false,
                    exclusive: false,
                },
            }, { min: 20, max: 20000, scaling: "exponential" }, "Hz", 100),
            11: Float32Field.create({
                parent: this,
                fieldKey: 11,
                fieldName: "carrierMaxFreq",
                deprecated: false,
                pointerRules: {
                    accepts: [
                        Pointers.Modulation,
                        Pointers.Automation,
                        Pointers.MIDIControl,
                    ],
                    mandatory: false,
                    exclusive: false,
                },
            }, { min: 20, max: 20000, scaling: "exponential" }, "Hz", 12000),
            12: Float32Field.create({
                parent: this,
                fieldKey: 12,
                fieldName: "modulatorMinFreq",
                deprecated: false,
                pointerRules: {
                    accepts: [
                        Pointers.Modulation,
                        Pointers.Automation,
                        Pointers.MIDIControl,
                    ],
                    mandatory: false,
                    exclusive: false,
                },
            }, { min: 20, max: 20000, scaling: "exponential" }, "Hz", 100),
            13: Float32Field.create({
                parent: this,
                fieldKey: 13,
                fieldName: "modulatorMaxFreq",
                deprecated: false,
                pointerRules: {
                    accepts: [
                        Pointers.Modulation,
                        Pointers.Automation,
                        Pointers.MIDIControl,
                    ],
                    mandatory: false,
                    exclusive: false,
                },
            }, { min: 20, max: 20000, scaling: "exponential" }, "Hz", 12000),
            14: Float32Field.create({
                parent: this,
                fieldKey: 14,
                fieldName: "qMin",
                deprecated: false,
                pointerRules: {
                    accepts: [
                        Pointers.Modulation,
                        Pointers.Automation,
                        Pointers.MIDIControl,
                    ],
                    mandatory: false,
                    exclusive: false,
                },
            }, { min: 1, max: 60, scaling: "exponential" }, "", 2),
            15: Float32Field.create({
                parent: this,
                fieldKey: 15,
                fieldName: "qMax",
                deprecated: false,
                pointerRules: {
                    accepts: [
                        Pointers.Modulation,
                        Pointers.Automation,
                        Pointers.MIDIControl,
                    ],
                    mandatory: false,
                    exclusive: false,
                },
            }, { min: 1, max: 60, scaling: "exponential" }, "", 20),
            16: Float32Field.create({
                parent: this,
                fieldKey: 16,
                fieldName: "envRelease",
                deprecated: false,
                pointerRules: {
                    accepts: [
                        Pointers.Modulation,
                        Pointers.Automation,
                        Pointers.MIDIControl,
                    ],
                    mandatory: false,
                    exclusive: false,
                },
            }, { min: 1, max: 1000, scaling: "exponential" }, "ms", 30),
            17: Float32Field.create({
                parent: this,
                fieldKey: 17,
                fieldName: "mix",
                deprecated: false,
                pointerRules: {
                    accepts: [
                        Pointers.Modulation,
                        Pointers.Automation,
                        Pointers.MIDIControl,
                    ],
                    mandatory: false,
                    exclusive: false,
                },
            }, "unipolar", "%", 1),
            18: Int32Field.create({
                parent: this,
                fieldKey: 18,
                fieldName: "bandCount",
                deprecated: false,
                pointerRules: NoPointers,
            }, { min: 8, max: 16 }, "", 16),
            19: StringField.create({
                parent: this,
                fieldKey: 19,
                fieldName: "modulatorSource",
                deprecated: false,
                pointerRules: NoPointers,
            }, "noise-pink"),
            20: Float32Field.create({
                parent: this,
                fieldKey: 20,
                fieldName: "envAttack",
                deprecated: false,
                pointerRules: {
                    accepts: [
                        Pointers.Modulation,
                        Pointers.Automation,
                        Pointers.MIDIControl,
                    ],
                    mandatory: false,
                    exclusive: false,
                },
            }, { min: 0.1, max: 100, scaling: "exponential" }, "ms", 5),
            21: Float32Field.create({
                parent: this,
                fieldKey: 21,
                fieldName: "gain",
                deprecated: false,
                pointerRules: {
                    accepts: [
                        Pointers.Modulation,
                        Pointers.Automation,
                        Pointers.MIDIControl,
                    ],
                    mandatory: false,
                    exclusive: false,
                },
            }, { min: -20, max: 20, scaling: "linear" }, "dB", 0),
            30: PointerField.create({
                parent: this,
                fieldKey: 30,
                fieldName: "sideChain",
                deprecated: false,
                pointerRules: NoPointers,
            }, Pointers.SideChain, false),
        };
    }
}
